import type { IBookErrorResponse, IBookingPageProps } from './types';

export interface IBookRequest {
  scheduledAt: string;
  timeZone: string;
  phone?: string;
}

export type BookResult =
  | { ok: true; props: IBookingPageProps }
  | { ok: false; error: IBookErrorResponse };

const csrfToken = () =>
  document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? '';

// The page has no login and no API client: it posts to its own token URL,
// with the Rails CSRF token from the layout.
export const bookCall = async (bookUrl: string, request: IBookRequest): Promise<BookResult> => {
  try {
    const response = await fetch(bookUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken()
      },
      body: JSON.stringify({
        scheduled_at: request.scheduledAt,
        time_zone: request.timeZone,
        phone: request.phone
      })
    });
    const body = await response.json().catch(() => ({}));
    if (response.ok) return { ok: true, props: body as IBookingPageProps };
    return { ok: false, error: { error: 'not_available', ...body } as IBookErrorResponse };
  } catch {
    return { ok: false, error: { error: 'not_available', message: 'network' } };
  }
};
